import React from 'react';
import { useCRM } from '../context/CRMContext';
import SettingsForm from '../components/Forms/SettingsForm';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSettings } = FiIcons;

const Settings = () => {
  const { settings, updateSettings } = useCRM();

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold text-gray-900">Settings</h1>
        <SafeIcon icon={FiSettings} className="h-8 w-8 text-gray-400" />
      </div>

      <SettingsForm defaultValues={settings} onSubmit={updateSettings} />
    </div>
  );
};

export default Settings;